import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { requestPDF } from 'services/exports/duck';
import { expandAllObjectives } from 'services/social/duck';
import { expandAllChannels as expandAllSiteDirectChannels } from 'services/siteDirect/duck';
import ProtectedComponent from 'hoc/ProtectedComponent';
import { ChannelActionButton } from 'components/atoms/buttons/ChannelActions';
import { DASHBOARDS_EXPORT_PDF } from 'constants/capabilities';

const ProtectedExportPDF = ProtectedComponent({
    requiredCapabilities: [DASHBOARDS_EXPORT_PDF]
})(props => (<ChannelActionButton disabled={props.exportInProgress} icon={'icon-export'} text={'Export to PDF'} className="hidden-print" onClick={props.onClick} />));


class ExportPDF extends Component {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        let timeout = 10;

        if (this.props.expandSocial) {
            timeout = 1000;
            this.props.expandAllObjectives();
        }

        if (this.props.expandSiteDirect) {
            timeout = 1000;
            this.props.expandAllSiteDirectChannels();
        }

        setTimeout(() => this.props.requestPDF({
            template: this.props.template,
            meta: this.props.meta
        }), timeout);
    }

    render() {
        const hasAccess = this.props.currentUser ?
            this.props.currentUser.scope.indexOf(DASHBOARDS_EXPORT_PDF) > -1 : false;
        const isDisabled = this.props.isDisabled;

        if (!hasAccess || isDisabled) {
            return null;
        }
        return (<ProtectedExportPDF disabled={this.props.exportInProgress} onClick={this.onClick} />);
    }
}

ExportPDF.propTypes = {
    template: PropTypes.string.isRequired,
    isDisabled: PropTypes.string,
    meta: PropTypes.object,
    expandSocial: PropTypes.bool,
    expandSiteDirect: PropTypes.bool
};

const mapStateToProps = state => ({
    currentUser: state.users.currentUser,
    exportInProgress: state.exports.inProgress
});

export default connect(mapStateToProps, {
    requestPDF,
    expandAllObjectives,
    expandAllSiteDirectChannels
})(ExportPDF);



// WEBPACK FOOTER //
// ./src/containers/buttons/ExportPDF.js